(ns practitest.frontend.permission-error.views
  (:require
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]))

(defn- go-back! []
  (if (> (.-length js/window.history) 1)
    (js/history.back)
    (set! (.-href js/window.location) "/")))

(defn permission-error-page [_route]
  (let [options @(re-frame/subscribe [::subs/options])]
    [:div.user-link-result-page.permission-error-page
     [:div.user-link-result-card.permission-error-card
      [icons/mux-fox-access-denied {:mascot-url (:fox-mascot-path options)}]
      [:h3.link-result-title.link-result-title--failure
       (get-translation "login.access-denied" "Access Denied")]
      [:p.link-result-description
       (get-translation "permission-error.description-line1" "You are not allowed to execute this action.")
       [:br]
       (get-translation "permission-error.description-line2" "Maybe you tried doing something you don't have permissions for.")]
      [:div.link-result-actions
       [buttons/button {:primary?  true
                         :class     "link-result-btn-close"
                         :text      (get-translation "permission-error.go-back" "Go Back")
                         :on-click  go-back!}]]
      [:p.link-result-support
       (get-translation "user-link-result.need-help" "Need Help?")
       " "
       [:a {:href "https://www.practitest.com/support" :target "_blank"}
        (get-translation "user-link-result.contact-support" "Contact Support")]]]]))
